import { reactive } from 'vue';

export const adminPermissionStore = reactive({
  requestPermission: false
})
